"use strict";import{Tab as e}from"./src/Tab.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tab",e);
//# sourceMappingURL=sp-tab.js.map
